<template>
  <div class="important-wrap">
    <div class="important-info">
      <el-row>
        <el-col
          v-for="columnName in infoList"
          :key="columnName"
          :span="columns[columnName].size||spanCol">
          <info-render
            v-if="formValues"
            :data="formValues[columnName]"
            :column="columns[columnName]"
            :minLength="columns[columnName].minLength"
            :isWrap="columns[columnName].isWrap">
            <template slot-scope="props">
              <el-row>
                <el-col style="text-align:right" :span="columns[columnName].labelSize||8">
                  <strong>{{columns[columnName].label}}：</strong>
                </el-col>
                <el-col :span="columns[columnName].labelSize?24-columns[columnName].labelSize:16" class="flex-right">
                  <span>{{ props.content }}</span>
                </el-col>
              </el-row>
            </template>
          </info-render>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import InfoRender from '@/components/InfoRender'

var spanCol = 6
if (/Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent)) {
  spanCol = 24
}

export default {
  name: 'important-info',
  components: {
    InfoRender
  },
  props: {
    infoList: Array,
    formValues: Object,
    columns: Object
  },
  data () {
    return {
      spanCol: spanCol
    }
  }
}
</script>
<style scoped lang="sass">
.important-wrap
  padding: 12px
  line-height: 2.4
  border: 1px solid #ddd
  .important-info
    margin: 0 auto
    width: 90%
.flex-info
  display: flex
.flex-left
  padding-right: 10px
  flex: 1
  text-align: right
.flex-right
  // text-align: right
  padding-left: 20px
  box-sizing: border-box
  overflow: hidden
  text-overflow: ellipsis
</style>



// WEBPACK FOOTER //
// ImportantInfo.vue?eca05bc0